import { HelpOutlineOutlined } from "@mui/icons-material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

import { DROPDOWN_HELP_ICON_OFFSET_PX } from "../dropdowns";

export const ExplanationIconWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "explanation-icon-wrapper",
})<{ $horizontalOffset?: number }>`
  position: absolute;
  top: 50%;
  inset-inline-start: 100%;
  margin-inline-start: ${({
    $horizontalOffset = DROPDOWN_HELP_ICON_OFFSET_PX,
  }) => $horizontalOffset}px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 1;
`;

export const ExplanationTooltipContent = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "explanation-tooltip-content",
})`
  max-width: 320px;
  white-space: pre-line;
  word-break: break-word;
`;

export const ExplanationButtonStyled = styled.button.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "explanation-icon-button",
})<{ $hasHelpLink?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: none;
  cursor: ${({ $hasHelpLink }) => ($hasHelpLink ? "pointer" : "default")};

  &:focus-visible {
    outline: 2px solid ${greyMui._500};
    outline-offset: 2px;
  }
`;

export const ExplanationIconStyled = styled(HelpOutlineOutlined)`
  color: ${greyMui._400};
  font-size: 24px;
  transition: color 0.2s ease;

  &:hover {
    color: ${greyMui._500};
  }
`;
